import React, { useState, useEffect } from "react";
import axios from "axios";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import HeaderEtd from '../../../shared/components/HeaderEtd';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { FaEdit } from "react-icons/fa";
import {
  FaUser,
  FaUsers,
  FaPaperPlane,
  FaFileExcel,
  FaFolderOpen,
} from "react-icons/fa";
import {
  getAppId,
  getLoginInfo,
  getSearchInfo,
  getSysId,
  setApplicantAss,
} from '../../../shared/utils/storage';
import ApplicantInfo from "./Applicant";
import PurposeInfo from "./Purpose";
import AttachmentsInfo from "./Documents";
import DecissionComponent from "./Action";
import ParentsInfo from "./Parents";
import { useLocation, useNavigate } from "react-router-dom";
import ContactPeople from "./ContactPeople";
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import SponsorInfo from "./Sponsors";
import PaymentsInfo from "./PaymentsInfo";

const ViewDetails = () => {
  const navigate = useNavigate();

  const newData = getSearchInfo()?.data;
  const stageID = newData?.ApplicationStatus[0]?.StageID;
  const applicationID = newData?.ApplicationStatus[0]?.ApplicationID;
  const isLockedApp = newData?.ApplicationStatus[0]?.IsApplicationLocked;
  const isLockedAppBy = newData?.ApplicationStatus[0]?.ApplicationLockedBy;

  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [isLocking, setIsLocking] = useState(false);
  const [isLocked, setIsLocked] = useState(isLockedApp);
  const [lockedBy, setIsLockedBy] = useState(isLockedAppBy);
  const [lockeMessage, setLockMessage] = useState();
  const styles = {
    h4: {
      color: "#850505",
      textTransform: "uppercase",
    },
  };

  useEffect(() => {
    applicaitonStatus();
  }, []);
  const applicaitonStatus = async () => {
    const payload = {
      ApplicationId: applicationID,
      UserName: getLoginInfo()?.user?.Username,
      StageId: "",
      Station: getLoginInfo()?.user?.StationID,
      Action: "Status",
      // AccessorId: getLoginInfo()?.user?.UserID,
    };

    const result = await handleApplicationManagement(
      payload,
      "application_management",
    );
    // setIsLocking(false)
    if (result?.code == "1") {
      const status = result.data[0];
      setIsLocked(status?.IsLocked);
      setIsLockedBy(status?.IsLockedBy);
    } else {
      //setIsLocked(false)
      setLockMessage(result?.message);
    }
  };

  const lockManagement = async (action) => {
    setIsLocking(true);
    const payload = {
      ApplicationId: applicationID,
      OperationType: action,
      Station: getLoginInfo()?.user?.StationID,
      UserName: getLoginInfo()?.user?.Username,
    };
    setLockMessage("");

    const result = await handleApplicationManagement(
      payload,
      "pull_management",
    );
    setIsLocking(false);
    if (result?.code == "1") {
      // this.callbackService.updateCallBack()
      if (action === "LOCKAPP") {
        let locker = getLoginInfo()?.user?.Username;
        setIsLockedBy(locker);
        setIsLocked(true);
      } else {
        setIsLocked(false);
      }
    } else {
      setIsLocked(false);
      setLockMessage(result?.message);
    }
  };
  const back = () => {
    switch (stageID) {
      case 510:
        navigate("/assessment");
        break;
      case 520:
        navigate("/approval");
        break;
      case 530:
        navigate("/po1");
        break;
      default:
        navigate("/dashboard");
    }
  };
  return (
    <>
      <HeaderEtd />
      <div className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              {/* <div className="card-body">
                <h2 style={{ color: "#c2c2c2" }}>
                  <i>Application Details</i>
                </h2>
              </div> */}
              <br />
              <div className="container-fluid" style={{ marginTop: "20px" }}>
                <div className="row">
                  {/*-----------------------------------------*/}
                  <div className="col-md-12">
                    <div className="card2">
                      <div className="card-body">
                        <div className="row">
                          <div
                            className="collapse barNav-collapse barNav-1 col-md-4"
                            style={{ marginTop: "0px" }}
                          >
                            {/* <b style={{ color: "green" }}>
                              <u>Applications In-progres:</u>
                              &nbsp;&nbsp;&nbsp;
                            </b> */}
                            Application No.:&nbsp;
                            <span style={styles.h4}> {applicationID}</span>{" "}
                            &nbsp;&nbsp;&nbsp;
                          </div>
                          <div className="col-md-4" style={{ marginTop: "0px" }}>
                            {isLocked && (
                              <p>
                                <b style={styles.h4}>locked by: {lockedBy}</b>
                              </p>
                            )}
                          </div>
                          {isLocked &&
                            getLoginInfo()?.user?.Username === lockedBy && (
                              <div
                                className="col-md-2"
                                style={{ marginTop: "0px" }}
                              >
                                <button
                                  className="btn btn-warning"
                                  onClick={() => lockManagement("UNLOCKAPP")}
                                  name="Action"
                                  style={{ height: "30px", padding: "5px" }}
                                >
                                  <b style={{ fontSize: "13px" }}>
                                    {isLocking ? "Wait..." : "Unlock"}
                                  </b>
                                </button>
                              </div>
                            )}
                          {/* <button className="btn btn-primary" style={{ height: "30px",padding:"5px" }} onClick={back}>Back</button> */}
                          {!isLocked && (
                            <div className="col-md-2" style={{ marginTop: "0px" }}>
                              <button
                                className="btn btn-success"
                                onClick={() => lockManagement("LOCKAPP")}
                                name="Action"
                                style={{ height: "30px", padding: "5px" }}
                              >
                                <b style={{ fontSize: "13px" }}>
                                  {isLocking ? "Wait..." : "Lock"}
                                </b>
                              </button>
                            </div>
                          )}

                          <div className="col-md-2" style={{ marginTop: "0px" }}>
                            <button
                              className="btn btn-primary"
                              onClick={back}
                              name="Action"
                              style={{ height: "30px", padding: "5px" }}
                            >
                              <b style={{ fontSize: "13px" }}>Back</b>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*-----------------------------------------*/}
                  <div className="col-md-12">
                    <div className="card2">
                      <div
                        className="card-body"
                        style={{ height: "32rem", overflowY: "scroll" }}
                      >
                        <Tabs defaultIndex={0}>
                          <TabList>
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUser />
                                &nbsp; Applicant
                              </b>
                              &nbsp;
                            </Tab>

                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUsers />
                                &nbsp; Parents
                              </b>
                              &nbsp;
                            </Tab>
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUsers />
                                &nbsp; Sponsor
                              </b>
                              &nbsp;
                            </Tab>

                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUsers />
                                &nbsp; Emergency
                              </b>
                              &nbsp;
                            </Tab>
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaPaperPlane />
                                &nbsp; Purpose
                              </b>
                              &nbsp;
                            </Tab>
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUsers />
                                &nbsp; Payments
                              </b>
                              &nbsp;
                            </Tab>
                            {/* <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaFileExcel />
                                &nbsp; Privious ETD
                              </b>
                              &nbsp;
                            </Tab> */}
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaFolderOpen />
                                &nbsp; Documents
                              </b>
                              &nbsp;
                            </Tab>
                            {isLocked &&
                              getLoginInfo()?.user?.Username === lockedBy && (
                                <Tab>
                                  &nbsp;
                                  <b style={{ fontSize: "17px" }}>
                                    <i
                                      className="fa fa-tasks"
                                      aria-hidden="true"
                                    ></i>
                                    &nbsp; ACTION
                                  </b>
                                  &nbsp;
                                </Tab>
                              )}
                          </TabList>
                          <TabPanel>
                            <br />
                            <ApplicantInfo />
                          </TabPanel>
                          <TabPanel>
                            <br />
                            <ParentsInfo />
                          </TabPanel>
                          <TabPanel>
                            <br />
                            <SponsorInfo />
                          </TabPanel>

                          <TabPanel>
                            <br />
                            <ContactPeople />
                          </TabPanel>

                          <TabPanel>
                            <br />
                            <PurposeInfo />
                          </TabPanel>
                          <TabPanel>
                            <br />
                            <PaymentsInfo />
                          </TabPanel>
                          {/* <TabPanel>
                            <br />
                            <PreviousEtd />
                          </TabPanel> */}
                          <TabPanel>
                            <br />
                            <AttachmentsInfo />
                          </TabPanel>
                          {isLocked &&
                            getLoginInfo()?.user?.Username === lockedBy && (
                              <TabPanel>
                                <br />
                                <DecissionComponent />
                              </TabPanel>
                            )}
                        </Tabs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDetails;
